/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-24.
 * Dynamic Table Component
 * Allows to add new records, finally returns an array with all records
 * Cols must complete only 11 not 12
 */
import React, { Component } from 'react';
import Add from 'material-ui/svg-icons/content/add-circle';
import Trash from 'material-ui/svg-icons/action/delete';
import { IconButton, TextField } from 'material-ui';
import { v1 } from 'node-uuid';
import DropDownSearch from './dropDownSearch';
import RemoteDropDownSearch from './remotedropDownSearch';
import { extractProperty, buildEmptyObjectFromModel } from '../../common/helpers';

class DynamicTable extends Component {

    constructor() {
        super();
        this.id = v1();
    }

    removeRow(index) {
        const { data, notify } = this.props;
        const newData = [...data.slice(0, index), ...data.slice(index + 1)];
        notify(newData);
    }

    addRow(row) {
        const { data, notify } = this.props;
        const newData = [...data, buildEmptyObjectFromModel(row)];
        notify(newData);
    }

    updateDataItem(row, prop, index, newValue) {
        const { notify, data } = this.props;
        const newRow = { ...row, [prop]: newValue };
        const newData = Object.assign([], data, { [index]: newRow });

        notify(newData);
    }

    renderCustomInput(column, index, value, row) {
        const { selects } = this.props;
        switch (column.type) {
            case 'label':
                return column.calculateValue(row);
            case 'text':
                return (
                    <TextField
                        id={`${this.id}_${column.type}`}
                        fullWidth
                        placeholder={column.title}
                        disabled={column.disabled && column.disabled(row)}
                        value={value}
                        onChange={(event, newValue) => {
                            this.updateDataItem(row, column.prop, index, newValue);
                        }}
                    />
                );
            case 'number':
                return (
                    <TextField
                        id={`${this.id}_${column.type}`}
                        inputStyle={{ textAlign: 'right' }}
                        hintStyle={{ textAlign: 'right' }}
                        min="1"
                        disabled={column.disabled && column.disabled(row)}
                        fullWidth
                        type="number"
                        placeholder={column.title}
                        value={value}
                        onChange={(event, newValue) => {
                            this.updateDataItem(row, column.prop, index, newValue);
                        }}
                    />
                );
            case 'autocomplete':
                return (
                    <DropDownSearch
                        id={`${this.id}_${column.type}`}
                        fullWidth
                        dataSource={extractProperty(selects[column.prop], 'name')}
                        disabled={column.disabled && column.disabled(row)}
                        value={value}
                        onNewRequest={(request, idx) => {
                            const newValue = selects[column.prop][idx].id;
                            this.updateDataItem(row, column.prop, index, newValue);
                        }}
                    />
                );
            case 'remote_autocomplete':
                return (
                    <RemoteDropDownSearch
                        id={`${this.id}_${column.type}`}
                        //searchText={column.customSearchText && column.customSearchText(row)}
                        dataSourceConfig={{ text: 'concept', value: 'concept' }}
                        entity='invoiceItems'
                        serviceName='invoiceItems'
                        disabled={column.disabled && column.disabled(row)}
                        url='/invoiceItems/search/findTop10ByConceptIgnoreCaseContaining'
                        projectionName='forListing'
                        onUpdateInput={() => this.updateDataItem(row, column.prop, index, {})}
                        onChange={(newValue) => {
                            this.updateDataItem(row, column.prop, index, newValue);
                        }}
                        onAdd={this.props.Actions.onAddPreInvoice}
                    />
                );
            default:
                return null;
        }
    }

    render() {
        const { columns = [], data = [], validateRow, extraRow, extraInitialRow } = this.props;

        return (
            <div>
                <div className="row margin-bottom-1 hidden-xs-down">
                    {
                        columns.map(({ title, colClass }, index) =>
                            <div className={colClass} key={index}>
                                <p className="text-bold text-color-light">{title}</p>
                            </div>
                        )
                    }
                </div>
                {
                    extraInitialRow && <div className="row form-rowdynamic">{extraInitialRow}</div>
                }
                <div>
                    {
                        data.map((row, index) => {
                            const isTheLastRow = data.length - 1 === index;
                            return (
                                <div className="row form-rowdynamic" key={index}>
                                    {
                                        columns.map((column, ind) => {
                                            return (
                                                <div
                                                    className={`${column.colClass} display-flex-center`}
                                                    key={ind}
                                                >
                                                    {
                                                        column.showAsLabel && column.showAsLabel(row) ?
                                                            column.customLabel(row) :
                                                            this.renderCustomInput(column, index, row[column.prop], row)
                                                    }
                                                </div>
                                            );
                                        })
                                    }
                                    <div className="col-md-1 col-xs-12">
                                        {
                                            isTheLastRow ?
                                                <IconButton
                                                    disabled={!validateRow(row)}
                                                    tooltip="Agregar"
                                                    iconStyle={{ color: '#0277BD' }}
                                                    onTouchTap={() => this.addRow(row)}
                                                >
                                                    <Add />
                                                </IconButton>
                                                : <IconButton
                                                    tooltip="Eliminar"
                                                    iconStyle={{ color: validateRow(row) ? '#555' : 'red' }}
                                                    onTouchTap={() => this.removeRow(index)}
                                                >
                                                    <Trash />
                                                </IconButton>
                                        }

                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
                {
                    extraRow && <div className="row form-rowdynamic">{extraRow}</div>
                }
            </div>
        );
    }
}

export default DynamicTable;



// WEBPACK FOOTER //
// ./components/data-containers/dynamicTableV2.js